import * as React from 'react';
import { HotKeys } from 'react-hotkeys';
import { ButtonSecondary, ElementLoader } from 'ui';
import { FIELD_TYPE } from 'app/infrastructure/simple-form/';
import { SerializeType } from 'app/infrastructure/simple-form/types';
import { simpleFieldForPath, SimpleFormValidationConfig } from 'app/infrastructure/simple-form';
import { STATE } from 'app/constants';
import { form, ReportId } from 'app/area/saved-reports/constants';
import { requiredValidation } from 'app/infrastructure/simple-form/validation/rules';
import { keyCodeTypes } from 'ui/common/key-code-types';
import { CreateFolderProps } from 'app/area/saved-reports/types';
import styles from './create-folder.scss';
import { FolderType } from 'app/area/case-report/case-listing/types';

export interface CreateFolderState {
  isOpen: boolean;
}

const SimpleForm = simpleFieldForPath(STATE.savedReport);

export class CreateFolder extends React.Component<CreateFolderProps, CreateFolderState> {
  private keyMap: any;
  private handlers: any;

  constructor(props: CreateFolderProps) {
    super(props);

    this.state = {
      isOpen: false
    };

    this.keyMap = {
      onClose: [keyCodeTypes.Esc]
    };

    this.handlers = {
      onClose: this.onToggle
    };
  }

  private validationConfig: SimpleFormValidationConfig = [
    requiredValidation(form.create_folder_input)
  ];

  private onCreate = () => {
    const { validate, translation, formValues, selectedReport, reportCategories } = this.props;
    const selectedFolder = formValues[form.folder];

    validate(this.validationConfig, () => {
      this.props.saveFolder({
        name: formValues[form.create_folder_input],
        ...(selectedFolder?.value && {
          parentFolder: formValues[form.folder].value
        }),
        ...(selectedReport === ReportId.CompanyReport && {
          folderType: FolderType.SpecialReport
        } || 
          selectedReport === ReportId.Dashboard && {
          folderType: FolderType.Dashboard
        })
      }, reportCategories);
      this.onToggle();
    }, translation.validation_error);
  };

  private onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    } as CreateFolderState);
  };

  public render() {
    const { translation, fetching, className, hideLinkButtonCreateFolder, hideLabel, hideCreateButton } = this.props;
    const showCreateFolderLinkButton = !hideLinkButtonCreateFolder && !this.state.isOpen && !fetching;
    const showCreateFolderInputField = !fetching && (hideLinkButtonCreateFolder ? true : this.state.isOpen);

    return <HotKeys keyMap={this.keyMap} handlers={this.handlers}>
      {showCreateFolderLinkButton && <button className={styles.link} onClick={this.onToggle}>
        + {translation.create_folder_link}
      </button>}
      {showCreateFolderInputField && <div>
        <div className={`${styles.wrapper} ${className || ''}`}>
          <div className={`${styles.input}`}>
            <SimpleForm
              name={form.create_folder_input}
              maxLength={254}
              type={FIELD_TYPE.TEXTAREA}
              label={!hideLabel && { text: translation.create_folder_link }}
              placeholder={translation.create_report_input_placeholder}
              serialize={{ type: SerializeType.PRIMITIVE_VALUE }}
              initialValue={''} />
          </div>
          {!hideCreateButton && <div className={`${styles.button}`}>
            <ButtonSecondary onClick={this.onCreate}>
              {translation.create_folder_button}
            </ButtonSecondary>
          </div>}
        </div>
      </div>}
      {fetching && <div className={styles.loader}>
        {<ElementLoader />}
      </div>}
    </HotKeys>;
  }
}
